export const SignatureCanvasResourcesDE: SignatureCanvasResourcesBSInterface = {
  clear: "Unterschrift löschen",
  save: "Unterschrift speichern",
};

export interface SignatureCanvasResourcesBSInterface {
  clear: string;
  save: string;
}
